import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import './Icon.scss';

export default function Icon({ type }) {
    return (
        <div className="icon-container">
            <span className={`${type}-icon-styles`} />
        </div>
    );
}

Icon.displayName = displayName('Dialog/Icon');

Icon.propTypes = {
    type: PropTypes.string.isRequired,
};
